import { STORE_INFO } from './store-info'

export const CONTACT_EMAIL = STORE_INFO.email

export function buildContactMailtoUrl(productName?: string): string {
  const subject = productName
    ? `Flora Ateliê — buquê ${productName}`
    : 'Flora Ateliê — encomenda de flores'
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`
}
